const review = {
  title: 'Kako vam je všeč aplikacija?',
  starHint: '1 = ni všeč, 5 = zelo všeč',
  commentPlaceholder: 'Predlogi za izboljšave (opcijsko)',
  submit: 'Pošlji',
};

export default review;
